import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLoading } from "../../../views/Loader/LoadingContext";
import CreatePurchaseOrder from "./CreatePurchaseOrder";

const CreatePurchaseOrderPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setLoading } = useLoading();

  // Get status from URL to preserve filter when navigating back
  const statusFilter = searchParams.get("status") || "";

  const handleBack = () => {
    setLoading(true);
    navigate(`/home${statusFilter ? `?status=${statusFilter}` : ""}`);
    setLoading(false);
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <div className="w-full p-4">
        <CreatePurchaseOrder onBack={handleBack} statusFilter={statusFilter} />
      </div>
    </div>
  );
};

export default CreatePurchaseOrderPage;
